<app-modal [modalTitleText]="headerText" [cancelButtonText]="closeText" [primaryButtonEnabled]="false" (cancelButtonAction)="closeModal()">
  <app-faq [footerStickyEnabled]="false" modal-content></app-faq>
</app-modal>
